import { Button } from 'react-bootstrap';
import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({ data }) => {
    return (
        <section className="mySlides">
            <div class="card card-custom mb-3" style={{ maxWidth: "800px" }}>
                <div class="row g-0">
                    <div class="col-md-4">
                        <img className="img-fluid img-custom" src={data.image} alt="..." />
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h2 class="card-title">{data.title}</h2>
                            <hr className="card-hr" />
                            <h5 className="card-text">
                                {
                                    data.tag.map(tags => tags !== "" && <span className="tag">{tags}</span>)
                                }
                            </h5>
                            <br />
                            <p class="card-text text-justify">{data.summary}</p>
                            <div className="row tech-bar">
                                <span className="col-6 purple">50%</span>
                                <span className="col-3 green">30%</span>
                                <span className="col-3 orange">30%</span>
                            </div>
                            <Button href={data.live} target="_blank" className="btn-custom" variant="outline-light">Live Preview</Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectCard;